import React, { useMemo } from 'react';

import {
  RecordContextProvider,
  ReferenceManyField, usePermissions, useRecordContext,
} from 'react-admin';

import {
  Grid,
  Card,
  CardHeader,
  Divider,
  CardContent,
  Box,
} from '@mui/material';

import { isEmpty } from 'lodash';
import Pagination from '../components/layout/Pagination';

import { IndividualListBody } from '../components/individual/IndividualList';
import NoResults from '../components/layout/NoResults';
import hasAccess from '../utilities/hasAccess';
import PermissionMissing from '../components/utils/PermissionMissing';
import actions, { Actions } from '../constants/actions';

const RelatedConductors = () => {
  const record = useRecordContext();

  const conductorIds = record?.conductors?.map((conductor: { id: string}) => conductor.id);

  const { permissions } = usePermissions<Actions[]>();
  const hasIndividualListPermission = useMemo(
    () => hasAccess(permissions, actions.INDIVIDUAL_LIST),
    [permissions],
  );

  return (
    <Grid size={12}>
      <Card variant="outlined">
        <CardHeader
          title="Related Conductors"
        />
        <Divider />

        {isEmpty(conductorIds) && hasIndividualListPermission && <NoResults variant="h4" />}
        {!isEmpty(conductorIds) && hasIndividualListPermission && (
          <RecordContextProvider value={{ ...record, conductorIds }}>
            <ReferenceManyField
              perPage={5}
              pagination={<Pagination disableEmptyText rowsPerPageOptions={[5, 10, 20]} />}
              reference="individuals"
              source="conductorIds"
              target="id"
            >
              <IndividualListBody />
            </ReferenceManyField>
          </RecordContextProvider>
        )}
        {!hasIndividualListPermission && (
          <CardContent>
            <Box display="flex" alignItems="center" width="100%" flexDirection="column">
              <PermissionMissing />
            </Box>
          </CardContent>
        )}
      </Card>
    </Grid>
  );
};

export default RelatedConductors;
